<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.back()"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <!-- 整体表单  -->
    <el-form ref="form" :model="form" label-width="120px">
      <div class="color4272ea fw-600">合伙人信息</div>
      <template v-if="status == 1">
        <el-form-item
          label="姓名"
          prop="userName"
          :rules="[
            {
              required: true,
              message: '姓名',
              trigger: 'blur'
            }
          ]"
        >
          <el-input v-model="form.userName" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item
          label="联系电话"
          prop="userPhone"
          :rules="[{ required: true, validator: phone, trigger: 'blur' }]"
        >
          <el-input
            v-model="form.userPhone"
            placeholder="请输入合伙人电话"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="维护人员"
          prop="staffId"
          :rules="[
            {
              required: true,
              message: '请选择维护人员',
              trigger: 'blur'
            }
          ]"
        >
          <el-select
            v-model="form.staffId"
            placeholder="请选择维护人员"
            @change="changeStaff"
          >
            <el-option
              v-for="(v, i) in people"
              :key="i"
              :label="v.name"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="身份证号码" prop="identityCard">
          <el-input
            v-model="form.identityCard"
            placeholder="请输入身份证号码"
          ></el-input>
        </el-form-item>
        <el-form-item label="说明" prop="particularDesc">
          <el-input
            placeholder="请输入"
            type="textarea"
            v-model="form.particularDesc"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="照片">
          <el-upload
            ref="upload"
            action="#"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
            :on-remove="handleRemove"
            :on-change="handleEditChange"
            :file-list="imgList"
            :http-request="uploadFile"
            :limit="3"
            :auto-upload="true"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="imgsVisible">
            <img
              width="100%"
              v-for="(item, index) in imgList"
              :src="item.url"
              alt=""
              :key="index"
            />
          </el-dialog>
        </el-form-item>
      </template>
      <template v-if="status == 2 || status == 3">
        <el-descriptions border :column="3">
          <el-descriptions-item label="合伙人姓名">{{
            form.userName
          }}</el-descriptions-item>
          <el-descriptions-item label="合伙人电话">{{
            form.userPhone
          }}</el-descriptions-item>
          <el-descriptions-item label="身份证号">{{
            form.identityCard
          }}</el-descriptions-item>
          <el-descriptions-item label="说明">{{
            form.particularDesc
          }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions border :column="4">
          <el-descriptions-item label="用户申请时间">{{
            form.createTime || "--"
          }}</el-descriptions-item>
          <el-descriptions-item label="员工提交时间">{{
            form.updateTime || "--"
          }}</el-descriptions-item>
          <el-descriptions-item label="审核时间">{{
            form.auditTime || "--"
          }}</el-descriptions-item>
          <el-descriptions-item label="审核人员">{{
            form.auditUserName || "--"
          }}</el-descriptions-item>
          <el-descriptions-item label="审核状态">
            <span v-if="status == 0">待提交</span>
            <span v-if="status == 1">待审核</span>
            <span v-if="status == 2">已通过</span>
            <span v-if="status == 3">已驳回</span>
          </el-descriptions-item>
          <el-descriptions-item label="审核备注">{{
            form.auditRemark || "--"
          }}</el-descriptions-item>
          <el-descriptions-item label="图片">
            <el-image
              v-if="imgList.length > 0"
              style="width: 100px; height: 100px"
              v-for="(v, i) in imgList"
              :key="i"
              :src="v"
              :preview-src-list="imgList"
            >
            </el-image>
            <el-empty v-else />
          </el-descriptions-item>
        </el-descriptions>
      </template>

      <!--      合伙人奖励提现-->
      <div class="color4272ea fw-600">合伙人奖励提现</div>
      <el-form-item
        label="提现方式"
        prop="awardWay"
        :rules="[
          {
            required: true,
            message: '请选择',
            trigger: 'blur'
          }
        ]"
      >
        <el-radio-group :disabled="status != 1" v-model="form.awardWay">
          <el-radio :label="0">全部</el-radio>
          <el-radio :label="1">现金提现</el-radio>
          <el-radio :label="2">水卡兑换</el-radio>
        </el-radio-group>
      </el-form-item>
      <!--      分润信息-->
      <div class="color4272ea fw-600">分润信息</div>
      <el-form-item label="分润方式">
        <div>合伙人充值分润</div>
      </el-form-item>
      <!--      维护区域-->
      <el-form-item label="维护区域">
        <!-- 分配区域数组 -->
        <el-button
          class="mgl-8"
          :disabled="status != 1"
          @click="
            form.partnerRegionBeanList = [partnerRegion()];
            $forceUpdate();
          "
          v-if="form.partnerRegionBeanList.length === 0"
          >添加分区
        </el-button>
        <div
          v-for="(v, i) in form.partnerRegionBeanList"
          :key="i"
          style="margin-bottom: 20px"
        >
          <div class="flex" style="background: var(--card-bg);padding: 20px 0 0 0">
            <div>
              <el-form-item
                label="区域名称"
                :prop="`partnerRegionBeanList.${i}.regionId`"
                :rules="[
                  { required: true, message: '请选择区域', trigger: 'blur' }
                ]"
              >
                <div class="flex aic">
                  <el-select
                    v-model="v.regionId"
                    placeholder="请选择区域"
                    @change="
                      v.regionName = (
                        fenquArr.find(i => i.id === v.regionId) || {}
                      ).regionName
                    "
                    :disabled="status != 1"
                  >
                    <el-option
                      v-for="(v, i) in fenquArr"
                      :key="i"
                      :label="v.regionName"
                      :value="v.id"
                    ></el-option>
                  </el-select>
                </div>
                <div class="flex aic" v-if="v.regionId">
                  <reginData
                    :regionId="v.regionId"
                    v-model:regionName="v.regionName"
                  >
                    <template #default="{equipment,card,shouyi}">
                      <span class="mgr-15">设备数量：{{ equipment }}台</span>
                      <span class="mgr-15">水卡数量：{{ card }}张</span>
                      <!--                      <span>区域剩余可分配收益：{{ shouyi }}%</span>-->
                    </template>
                  </reginData>
                </div>
              </el-form-item>
              <el-form-item
                label="分润比例"
                :prop="`partnerRegionBeanList.${i}.regionRatio`"
                :rules="[
                  {
                    required: true,
                    validator: regionRatioValidator(v),
                    trigger: 'blur'
                  }
                ]"
              >
                <div style="display: flex;flex-direction: column">
                  <div>
                    <el-input-number
                      v-model="v.regionRatio"
                      placeholder="请输入分润比例"
                      :min="0"
                      :max="100"
                      :precision="0"
                      style="width: 160px"
                      :disabled="status != 1"
                    >
                    </el-input-number>
                    %
                  </div>
                  <span
                    style="color: rgba(255, 0, 0, 1);
    font-size: 14px;"
                    >注:指订单实付金额的比例</span
                  >
                </div>
              </el-form-item>
              <el-form-item
                label="到期自动回收"
                :prop="`partnerRegionBeanList.${i}.autoRecovery`"
                :rules="[
                  { required: true, message: '请选择', trigger: 'blur' }
                ]"
              >
                <el-radio-group
                  v-model="v.autoRecovery"
                  @change="$forceUpdate()"
                  :disabled="status != 1"
                >
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="v.autoRecovery == 1"
                label="到期时间"
                :prop="`partnerRegionBeanList.${i}.recoveryTime`"
                :rules="[
                  { required: true, message: '请选择时间', trigger: 'blur' }
                ]"
              >
                <el-date-picker
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  v-model="v.recoveryTime"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                  @input="$forceUpdate()"
                >
                </el-date-picker>
              </el-form-item>
            </div>
            <div>
              <el-button
                type="text"
                size="small"
                class="mgl-8"
                @click="addDomain"
                :disabled="status != 1"
                v-if="i === form.partnerRegionBeanList.length - 1"
                >添加
              </el-button>
              <el-button
                type="text"
                size="small"
                class="mgl-8"
                style="color:var(--danger)"
                :disabled="status != 1"
                @click.prevent="removeDomain(v)"
                >删除
              </el-button>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="维护人分润">
        <!-- 分配区域数组 -->
        <el-button
          class="mgl-8"
          @click="
            form.partnerStaffList = [partnerStaff()];
            $forceUpdate();
          "
          :disabled="status != 1"
          v-if="form.partnerStaffList.length === 0"
          >添加维护人
        </el-button>
        <div
          v-for="(v, i) in form.partnerStaffList"
          :key="i"
          style="margin-bottom: 20px"
        >
          <div class="flex" style="background: var(--card-bg);padding: 20px 0 0 0">
            <div class="flex  flex-w" style="align-items: start">
              <el-form-item
                label="分润人"
                :prop="`partnerStaffList.${i}.afterSalesId`"
                :rules="[
                  { required: true, message: '请选择分润人', trigger: 'blur' }
                ]"
              >
                <div class="flex " style="margin-bottom: 20px">
                  <el-select
                    v-model="v.afterSalesId"
                    placeholder="请选择分润人"
                    @change="
                      v.afterSalesName = (
                        people.find(i => i.id === v.afterSalesId) || {}
                      ).name
                    "
                    :disabled="status != 1"
                    style="width: 160px !important"
                  >
                    <el-option
                      v-for="(v, i) in people.filter(
                        item =>
                          !form.partnerStaffList
                            .map(i => i.afterSalesId)
                            .includes(item.id) || item.id === v.afterSalesId
                      )"
                      :key="i"
                      :label="v.name"
                      :value="v.id"
                    ></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item
                label="分润比例"
                :prop="`partnerStaffList.${i}.sharingProportion`"
                :rules="[
                  {
                    required: true,
                    validator: partnerSharingProportionValidator(v),
                    trigger: 'blur'
                  }
                ]"
              >
                <div style="display: flex;flex-direction: column">
                  <div>
                    <el-input-number
                      v-model="v.sharingProportion"
                      placeholder="请输入分润比例"
                      :min="0"
                      :max="100"
                      :precision="0"
                      style="width: 160px"
                      :disabled="status != 1"
                    >
                    </el-input-number>
                    %
                  </div>
                  <span
                    style="color: rgba(255, 0, 0, 1);
    font-size: 14px;"
                    >注:指订单实付金额的比例</span
                  >
                </div>
              </el-form-item>
              <el-form-item
                label="新用户奖励"
                :prop="`partnerStaffList.${i}.newUserRewards`"
              >
                <div style="display: flex;flex-direction: column">
                  <div>
                    <el-input-number
                      v-model="v.newUserRewards"
                      placeholder="请输入新用户奖励"
                      :min="0"
                      style="width: 160px;"
                      :disabled="status != 1"
                    >
                    </el-input-number>
                    元
                  </div>
                </div>
              </el-form-item>
            </div>
            <div>
              <el-button
                type="text"
                size="small"
                class="mgl-8"
                @click="addPartnerStaff"
                :disabled="status != 1"
                v-if="i === form.partnerStaffList.length - 1"
                >添加
              </el-button>
              <el-button
                type="text"
                size="small"
                class="mgl-8"
                style="color:var(--danger)"
                :disabled="status != 1"
                @click.prevent="removePartnerStaff(v)"
                >删除
              </el-button>
            </div>
          </div>
        </div>
      </el-form-item>
      <!--      <el-form-item label="分润方式"-->
      <!--        ><span-->
      <!--          >新用户开卡<span style="color:red;"-->
      <!--            >(新用户首次充值后奖励)</span-->
      <!--          ></span-->
      <!--        ></el-form-item-->
      <!--      >-->
      <!--      <el-form-item label="新用户开卡奖励" prop="newUserState">-->
      <!--        <el-radio-group v-model="form.newUserState" :disabled="status != 1">-->
      <!--          <el-radio :label="1">开启</el-radio>-->
      <!--          <el-radio :label="0">关闭</el-radio>-->
      <!--        </el-radio-group>-->
      <!--      </el-form-item>-->
      <!--      <el-form-item-->
      <!--        label="奖励金额"-->
      <!--        prop="awardMoney"-->
      <!--        v-if="form.newUserState == 1"-->
      <!--        :rules="[{ required: true, validator: awardMoney, trigger: 'blur' }]"-->
      <!--      >-->
      <!--        <el-input-->
      <!--          v-model="form.awardMoney"-->
      <!--          placeholder="请输入奖励金额"-->
      <!--          :disabled="status != 1"-->
      <!--        >-->
      <!--          <template slot="append">元</template>-->
      <!--        </el-input>-->
      <!--      </el-form-item>-->
      <div class="color4272ea fw-600">业绩考核机制</div>
      <el-form-item
        label="业绩考核"
        prop="performanceCheck"
        :rules="[{ required: true, message: '请选择区域', trigger: 'blur' }]"
      >
        <el-radio-group v-model="form.performanceCheck" :disabled="status != 1">
          <el-tooltip
            class="item"
            effect="dark"
            content="开启后，合伙人在考核周期内业绩未达标，且满足连续未达标次数时，账号将锁定，无法继续使用[水卡充值]与[水卡绑定]功能，可通过解锁对账号进行恢复。"
            placement="top-start"
          >
            <el-radio :label="1">开启</el-radio>
          </el-tooltip>

          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="充值实付指标"
        prop="rechargeTarget"
        v-if="form.performanceCheck === 1"
        :rules="[{ required: true, validator: assessTo, trigger: 'blur' }]"
      >
        <el-input
          v-model="form.rechargeTarget"
          placeholder="请输入0-9999.9以内数字"
          :disabled="status != 1"
        >
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item
        prop="checkPeriod"
        v-if="form.performanceCheck === 1"
        :rules="[{ required: true, validator: assessPeriod, trigger: 'blur' }]"
      >
        <template #label>
          考核周期
          <el-tooltip
            class="item"
            effect="dark"
            content="考核从次日凌晨开始，设置当天纳入第一次考核周期内。"
            placement="top-start"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <el-input
          v-model="form.checkPeriod"
          placeholder="请输入1-365以内数字"
          :disabled="status != 1"
        >
          <template slot="append">天</template>
        </el-input>
      </el-form-item>
      <el-form-item
        label="连续未达标次数"
        prop="notQualified"
        v-if="form.performanceCheck === 1"
        :rules="[{ required: true, validator: notAssess, trigger: 'blur' }]"
      >
        <el-input
          v-model="form.notQualified"
          placeholder="请输入1-99以内数字"
          :disabled="status != 1"
        >
          <template slot="append">次</template>
        </el-input>
      </el-form-item>
      <!--  -->
      <el-form-item>
        <template v-if="status == 1">
          <el-button class="mgr-50" @click="handlePass">驳 回</el-button>
          <el-button type="primary" @click="handleTurn('form')"
            >通 过</el-button
          >
        </template>
        <template v-else>
          <el-button type="primary" @click="$router.back()">已知晓</el-button>
        </template>
      </el-form-item>
    </el-form>

    <!-- 弹框 驳回通过 -->
    <el-dialog
      title="操作确认"
      :visible.sync="dialogVisible"
      width="450px"
      center
      top="60vh"
    >
      <div class="center f20">
        {{ checkType == 1 ? "确认通过合伙人申请吗?" : "确定驳回合伙人申请吗" }}
      </div>
      <el-form
        class="mgt-15"
        ref="checkForm"
        :model="checkForm"
        label-width="80px"
      >
        <el-form-item
          label="备注"
          prop="auditRemark"
          :rules="[
            {
              required: true,
              message: '请输入备注信息',
              trigger: 'blur'
            }
          ]"
        >
          <el-input
            placeholder="请输入"
            type="textarea"
            v-model="checkForm.auditRemark"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" class="mgr-30"
          >取 消</el-button
        >
        <el-button type="primary" @click="checkBtn('checkForm')">{{
          checkType == 1 ? "通 过" : "驳 回"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import {
  handleConfirm,
  handleAlert,
  isHandleConfirm
} from "../../components/UtilsIf";
import {
  phone,
  identityCard,
  awardMoney,
  regionRatio,
  assessTo,
  assessPeriod,
  notAssess
} from "../../utils/tool";
import reginData from "@/views/partner/components/reginData.vue";
import { assignObject } from "@/utils/UtilsIf";
import { getPartnerApplyRegionList } from "@/api/partner";
const partnerRegion = (data = {}) => {
  return {
    regionId: null,
    equipment: null,
    card: null,
    shouyi: null,
    regionName: null,
    regionRatio: 0,
    autoRecovery: 0,
    ...data
  };
};
const partnerStaff = (data = {}) => {
  return {
    afterSalesId: null,
    afterSalesName: null,
    newUserRewards: null,
    sharingProportion: 0,
    ...data
  };
};
export default {
  components: {
    reginData,
    breadcrumbs
  },
  data() {
    return {
      partnerRegion,
      partnerStaff,
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0); // 重置为当天 00:00:00
          return time.getTime() <= today.getTime(); // 今天及之前都禁用
        }
      },
      imgsVisible: false,
      imgList: [],
      form: {
        userName: "",
        userPhone: "",
        staffId: "",
        identityCard: "",
        particularDesc: "",
        photoDesc: "",
        // newUserState: 0,
        awardWay: 0,
        // awardMoney: "",
        partnerRegionBeanList: [],
        partnerStaffList: [],
        performanceCheck: 0,
        rechargeTarget: "",
        checkPeriod: "",
        notQualified: "",
        auditRemark: "",
        auditTime: "",
        auditUserName: ""
      },
      dialogVisible: false,
      checkType: 1,
      checkForm: {
        auditRemark: ""
      },
      fenquArr: [],
      people: [],
      id: null,
      status: null
    };
  },
  created() {
    if (this.$route.query.id) {
      this.status = this.$route.query.status;
      this.id = this.$route.query.id;
      this.getDetail();
    }
    this.getFenqu();
    this.getPeoplePull();
  },
  methods: {
    phone,
    identityCard,
    awardMoney,
    regionRatio,
    assessTo,
    assessPeriod,
    notAssess,
    changeStaff() {
      if (this.addOrEditType === 1) {
        const result = this.people.find(item => item.id === this.form.staffId);
        if (result) {
          this.form.partnerStaffList = [
            partnerStaff({
              afterSalesId: result.id,
              afterSalesName: result.name
            })
          ];
        }
      }
    },
    regionRatioValidator(v) {
      const remainRegionRatio = this.form.partnerRegionBeanList.reduce(
        (acc, curr) => acc + curr.regionRatio,
        0
      );
      return (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入"));
        } else if (remainRegionRatio > 100) {
          callback(new Error("剩余比例不足"));
        } else {
          callback();
        }
      };
    },
    partnerSharingProportionValidator(v) {
      const remainRegionRatio = this.form.partnerStaffList.reduce(
        (acc, curr) => acc + curr.sharingProportion,
        0
      );
      return (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入"));
        } else if (remainRegionRatio > 100) {
          callback(new Error("剩余比例不足"));
        } else {
          callback();
        }
      };
    },
    checkBtn(d) {
      this.$refs[d].validate(valid => {
        if (valid) {
          this.$api.partner
            .partnerApplyCheck({
              id: this.id,
              ...this.form,
              partnerRegionBeanList: this.form.partnerRegionBeanList.map(
                item => ({
                  ...item,
                  regionRatio: item.regionRatio
                    ? Number(item.regionRatio) / 100
                    : 0
                })
              ),
              partnerStaffList: this.form.partnerStaffList.map(item => ({
                ...item,
                sharingProportion: item.sharingProportion
                  ? Number(item.sharingProportion) / 100
                  : 0
              })),
              ...this.checkForm,
              status: this.checkType == 1 ? 2 : 3
            })
            .then(res => {
              if (res.code === 200) {
                handleAlert("审核成功", "success");
                this.$router.push("/partner/partnerApply");
              }
            });
        } else {
          return false;
        }
      });
    },

    // 回显--详情
    getDetail() {
      this.$api.partner.getPartnerApplyInfo({ id: this.id }).then(async res => {
        if (res.code === 200) {
          let data = res.data;
          this.form = assignObject(this.form, {
            ...data,
            partnerRegionBeanList: data.regionId
              ? [
                  partnerRegion({
                    regionId: data.regionId,
                    regionName: data.regionName,
                    regionRatio: data.shareMoneyRatio
                      ? data.shareMoneyRatio * 100
                      : ""
                  })
                ]
              : []
          });
          this.imgList = [];
          if (data.photoDesc) {
            this.imgList = data.photoDesc
              .split(",")
              .map(item => ({ url: item }));
          }
        }
      });
    },
    // 分区下拉
    getFenqu() {
      this.$api.marketing.allZonePull().then(res => {
        if (res.code === 200) {
          this.fenquArr = res.data;
        }
      });
    },
    getPeoplePull() {
      this.$api.partner.weihuPeoplePull().then(res => {
        if (res.code === 200) {
          this.people = res.data.list;
        }
      });
    },
    handlePass() {
      this.checkType = 0;
      this.checkForm = {
        auditRemark: ""
      };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.checkForm.clearValidate();
      });
      this.dialogVisible = true;
    },
    handleTurn(d) {
      this.$refs[d].validate(async valid => {
        if (valid) {
          // 提示内容
          if (
            this.form.partnerRegionBeanList.find(item => item.regionRatio > 5)
          ) {
            const isSure = await isHandleConfirm(
              "当前分润比例较高，请确认是否继续。",
              "warning"
            );
            if (!isSure) return;
          }
          this.checkType = 1;
          this.checkForm = {
            auditRemark: ""
          };
          this.dialogVisible = true;
        } else {
          return false;
        }
      });
    },
    // 添加区域
    addDomain() {
      this.form.partnerRegionBeanList.push(partnerRegion());
      this.$forceUpdate();
    },
    //合伙人添加维护人分润
    addPartnerStaff() {
      this.form.partnerStaffList.push(partnerStaff());
      this.$forceUpdate();
    },
    // 删除区域
    removeDomain(item) {
      handleConfirm("确认删除该区域吗?", "info")
        .then(() => {
          var index = this.form.partnerRegionBeanList.indexOf(item);
          if (index !== -1) {
            this.form.fenqu.splice(index, 1);
            this.$forceUpdate();
          }
        })
        .catch(() => {
          return;
        });
    },
    //删除维护人分润
    removePartnerStaff(item) {
      handleConfirm("确认删除该维护人吗?", "info")
        .then(() => {
          var index = this.form.partnerStaffList.indexOf(item);
          if (index !== -1) {
            this.form.partnerStaffList.splice(index, 1);
            this.$forceUpdate();
          }
        })
        .catch(() => {
          return;
        });
    },
    // 照片上传
    // 凭证图片上传------
    handlePictureCardPreview(file) {
      this.imgsVisible = true;
    },
    handleRemove(file, fileList) {
      this.imgList = fileList;
      this.form.photoDesc = this.imgList.map(item => item.url).join(",");
    },
    /* 自定义上传 */
    uploadFile(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("files", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.shebei.uploadHeader(formData).then(res => {
        if (res.code === 200) {
          this.imgList.push({
            url: res.data[0]
          });
          this.form.photoDesc = this.imgList.map(item => item.url).join(",");
        }
      });
      /* ------------------------------------ */

      // // 成功失败都删除文件;
      // this.fileList.splice(-1, 1);
    },
    // 图片超出张数不显示上传框
    handleEditChange(file, fileList) {
      console.log(fileList, "fileList");
      console.log(this.limitCount, "this.limitCount");
    }
  }
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select,
.el-textarea {
  width: 300px !important;
}
</style>
